module.exports = __webpack_public_path__ + "img/canada-breast-cancer-female.ee08f67b.png";